<template>
	<select
		type="text"
		v-model="inputValue"
		:name="name"
		:id="id"
		:autocomplete="autocomplete"
		:placeholder="placeholder"
		:class="inputClassListLive"
		:readonly="readonlyLive"
		:required="requiredLive"
		:disabled="disabledLive"
		:title="inputValue"
		:optionValue="optionTrackBy"
		:optionLabel="optionLabel"
		:multiple="multiple"

		@input="onInputHandler"
		@change="onChangeHandler"
		@focus="onFocusHandler"
		@blur="onBlurHandler"
	>
		<option v-for="option in options" v-bind:value="option[optionTrackBy]">
			{{ option[optionLabel] }}
		</option>
	</select>
</template>

<script>
import {baseInput} from './../mixins/index.js';

export default {
	name: 'SelectInput',
	props: {
		multiple: {type: Boolean, required: false, default: false},
		options: {type: Array, required: false, default: () => []},
		optionLabel: {type: String, required: false, default: "text"},
		optionTrackBy: {type: String, required: false, default: "value"},
	},
	mixins: [baseInput]
};
</script>
